/*
 * Copyright © Scale Microgrid Solutions Operating, LLC [2023].
 * All rights reserved.
 *
 * SPDX-FileCopyrightText: ©2022 Scale Microgrid Solutions Operating, LLC <legal@scalemicrogrids.com>
 */

import React from "react";
import { Box } from "@mui/material";

/**
 * Wrapper component for the 2025 Metered static HTML page.
 * This component renders an iframe that loads the static HTML content.
 * Authentication is enforced by this route being inside the logged-in routes.
 */
const Metered2025 = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: "hidden",
      }}
    >
      <iframe
        src="/static/2025metered/index.html"
        title="2025 Metered"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </Box>
  );
};

export default Metered2025;
